import React from 'react';

const CampaignBenefits = ({
  id = 'beneficios',
  ariaLabel,
  kicker,
  title,
  ctaLabel,
  onCtaClick,
  cards,
}) => (
  <section id={id} className="hhc-beneficios" aria-label={ariaLabel}>
    <div className="hhc-bfx-header hhc-reveal">
      <div>
        <div className="hhc-kicker">{kicker}</div>
        <h2 className="hhc-h-display">{title}</h2>
      </div>
      <a href="#contato" className="hhc-btn hhc-btn-outline-red" onClick={onCtaClick}>
        {ctaLabel}
      </a>
    </div>
    <div className="hhc-bfx-grid">
      {cards.map((card, index) => (
        <div
          key={card.id ?? index}
          className="hhc-bfx-card hhc-reveal"
          style={{ transitionDelay: `${0.05 + index * 0.05}s` }}
        >
          <div className="hhc-bfx-icon">{card.icon}</div>
          <div className="hhc-bfx-t">{card.title}</div>
          <div className="hhc-bfx-p">{card.text}</div>
        </div>
      ))}
    </div>
  </section>
);

export default CampaignBenefits;
